async function getPrivacyPolicy() {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_BASE_URL}/api/privacy-policy`,
    );
    return response.json();
  } catch (error) {
    throw new Error(error.message);
  }
}

export default getPrivacyPolicy;
